import { Grid, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
// component
import MyButton from "components/button/Button";
import { useApiAction, useFetchData } from "hook/useFetchData";
import { renderFormControl } from "components/FormManage/index";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
// direct components
import "../../renewal.scss";
import { cancelButton, header, submitButton } from "../../helper";

const Header = ({
  handleFilter,
  value,
  reset,
  handleReset,
  tableLoading,
  handleSearch,
}) => {
  const [openTag, setOpenTag] = useState(false);
  const [contactTag, setContactTag] = useState(false);
  const [noOpenTag, setNoOpenTag] = useState(false);
  const [noContactTag, setNoContactTag] = useState(false);
  const {
    data: billingData,
    loading: loadingBilling,
    fetchWithDelay,
  } = useFetchData(FinanceSettingService.getAccountBillingTypes);

  const {
    execute: getCategoryListByType,
    loading: loadingCategory,
    data: categoryData,
  } = useApiAction((token, type) =>
    MembersSettingService.getCatagoryListByType(type, token)
  );

  useEffect(() => {
    return fetchWithDelay();
  }, []);

  const handleChange = async (item) => {
    const type = item?.value;
    getCategoryListByType(type);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box sx={{ mt: 5, px: 4, mb: 3 }}>
          <Grid container spacing="3">
            {header(
              billingData,
              loadingBilling,
              handleChange,
              categoryData,
              loadingCategory,
              openTag,
              setOpenTag,
              contactTag,
              setContactTag,
              handleSearch,
              noOpenTag,
              setNoOpenTag,
              noContactTag,
              setNoContactTag
            )?.map((item, index) => (
              <Grid
                item
                xs={12}
                md={item?.grid ?? 12}
                key={index}
                sx={{ mb: 2 }}
              >
                {renderFormControl(item)}
              </Grid>
            ))}
          </Grid>
          <Box display="flex" justifyContent="flex-end" sx={{ mt: 3 }}>
            {/* <MyButton
              onClick={() => handleReset(reset)}
              style={cancelButton}
              type="button"
              disabled={tableLoading}
            >
              Clear
            </MyButton> */}
            <MyButton
              onClick={() => handleFilter(value)}
              style={submitButton}
              type="button"
              disabled={tableLoading}
            >
              {!tableLoading ? (
                "Filter"
              ) : (
                <>
                  Loading<span className="loading-dots"></span>
                </>
              )}
            </MyButton>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Header;
